// Gastrointestinal subsection form field enum
export enum GastrointestinalFormField {
  GASTROINTESTINAL_GI_ASSESSMENT = 'medicalBackground/gastrointestinal/giAssessment',
  GASTROINTESTINAL_BM_DATE = 'medicalBackground/gastrointestinal/bmDate',
  GASTROINTESTINAL_GU_ASSESSMENT = 'medicalBackground/gastrointestinal/guAssessment',
  GASTROINTESTINAL_CATHETER = 'medicalBackground/gastrointestinal/catheter',
  GASTROINTESTINAL_CATHETER_TYPE = 'medicalBackground/gastrointestinal/catheterType',
  GASTROINTESTINAL_FEEDING_TUBE = 'medicalBackground/gastrointestinal/feedingTube',
  GASTROINTESTINAL_FEEDING_TUBE_AMOUNT = 'medicalBackground/gastrointestinal/feedingTubeAmount',
  GASTROINTESTINAL_FEEDING_TUBE_DURATION = 'medicalBackground/gastrointestinal/feedingTubeDuration',
  GASTROINTESTINAL_FEEDING_TUBE_TYPE = 'medicalBackground/gastrointestinal/feedingTubeType',
  GASTROINTESTINAL_FEEDING_TUBE_SIZE = 'medicalBackground/gastrointestinal/feedingTubeSize',
  GASTROINTESTINAL_FEEDING_TOTAL_NUMBER = 'medicalBackground/gastrointestinal/feedingTotalNumber',
  GASTROINTESTINAL_FEEDING_TUBE_SITE = 'medicalBackground/gastrointestinal/feedingTubeSite',
  GASTROINTESTINAL_FEEDING_TUBE_NOTES = 'medicalBackground/gastrointestinal/feedingTubeNotes',
  GASTROINTESTINAL_NUTRITION_WNL = 'medicalBackground/gastrointestinal/nutritionWnl',
  GASTROINTESTINAL_NUTRITIONAL_FACTORS = 'medicalBackground/gastrointestinal/nutritionalFactors',
  GASTROINTESTINAL_DIET_REQUIREMENTS = 'medicalBackground/gastrointestinal/dietRequirements',
  GASTROINTESTINAL_NUTRITION_NOTES = 'medicalBackground/gastrointestinal/nutritionNotes',
  GASTROINTESTINAL_NUTRITIONAL_SCREENING = 'medicalBackground/gastrointestinal/nutritionalScreening',
  GASTROINTESTINAL_HISTORY_NOTES = 'medicalBackground/gastrointestinal/historyNotes',
  GASTROINTESTINAL_SYSTEM_SUMMARY = 'medicalBackground/gastrointestinal/systemSummary'
}
